import { render, staticRenderFns } from "./TeacherDetail.vue?vue&type=template&id=7a9d893f&scoped=true"
import script from "./TeacherDetail.vue?vue&type=script&lang=js"
export * from "./TeacherDetail.vue?vue&type=script&lang=js"
import style0 from "./TeacherDetail.vue?vue&type=style&index=0&id=7a9d893f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9d893f",
  null
  
)

export default component.exports